import 'css-chunksrc/client/scenes/transferProjectResourceAllocations/list/styles.scss';export default {
  "list": "_list_sow64_1",
  "main": "_main_sow64_5",
  "header": "_header_sow64_10",
  "iconBox": "_iconBox_sow64_22",
  "icon": "_icon_sow64_22",
  "openedIcon": "_openedIcon_sow64_39",
  "row": "_row_sow64_43",
  "avatar": "_avatar_sow64_50",
  "col": "_col_sow64_55",
  "name": "_name_sow64_64",
  "profession": "_profession_sow64_73",
  "selected": "_selected_sow64_78"
};